;(({ $, $$}) => {
    
    $$('.js-reveal-children').forEach(reveal => {
        const trigger = reveal.querySelector(".js-reveal-children-trigger")
        const shouldHideTrigger = reveal.dataset.hasOwnProperty('hideTrigger')
        const targets = reveal.querySelectorAll('.js-reveal-children-target')

        trigger.addEventListener('click', event => {
            event.preventDefault()

            if (shouldHideTrigger) {
                trigger.parentNode.removeChild(trigger)
            }

            targets.forEach(t => t.classList.remove('display-none'))
            
        })
    })
})(CNS);